export default __webpack_public_path__ + "static/media/sendButtonPic.bb66c11b.svg";